import React, { Component } from 'react';
import { Select, DatePicker, message, } from 'antd';
import Loader from '../../../Common/Component/Loader';
import moment from 'moment-timezone';
import { map } from 'lodash';
import {errorHandle} from "../../../Common/errorHandle";
import { formatToCurrency } from '../../../../Tools/formatToCurrency';
const { Option } = Select;


class SalesByItem extends Component {
  state = {
    franchiseList: [],
    franchise_name: '',
    SalesByItem: {},
    selected_date: moment(),
    filter: {
      field_office__uuid: '',
      created_at__month: '',
      created_at__year: ''

    },
    loader: false
  }


  componentDidMount = () => {
    let { filter } = this.state;

    this.props.getFranchiseList({ limit: 15, offset: 0 });

    filter = Object.assign(filter, { created_at__month: moment().format('MM'), created_at__year: moment().format('YYYY') })
    this.setState({
      filter
    })

    //Get Sales item report
    this.props.getSalesByItem({ created_at__month: moment().format('MM'), created_at__year: moment().format('YYYY') });
    this.setState({
      loader: true
    })
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    // message.destroy();
    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      errorHandle(props.FranchiseList.errors)
    }


    if (Object.keys(props.SalesByItem.data).length > 0) {
      this.setState({
        SalesByItem: props.SalesByItem.data,
      })
    }
    else {
      this.setState({
        SalesByItem: {}
      })
    }


    if (Object.keys(props.SalesByItem.errors).length > 0 && props.SalesByItem.errors !== this.props.SalesByItem.errors) {
      // display error messsage
      errorHandle(props.SalesByItem.errors)
    }
    this.setState({ loader: false })
  }

  render() {
    let { franchiseList, filter, franchise_name, selected_date, SalesByItem, loader } = this.state;



    return (
      <div className=" sales-item">
        <ul className="breadcrumb"><li onClick={() => { this.props.ChangeComponent(0) }}><span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span></li></ul>
        <div className="block-row">
          <div className="filter_wrapper p-0">
            <div className="left_side">
              <h2 className="m-0">Sales By Item</h2>
            </div>
            <div className="right_side">
              <div className="form-group flex ai-center fltr-txt">
                <div className="fitem">
                  <Select
                    className="swhite franchise_filter"
                    showSearch
                    showArrow={true}
                    suffixIcon={<i className="las la-angle-down"></i>}
                    defaultValue=""
                    onSearch={(e) => { this.props.getFranchiseList({ search: e }) }}
                    disabled={this.props?.is_disable_franchise ? true : false}
                    onBlur={() => { this.props.getFranchiseList({ limit: 10, offset: 0 }) }}
                    onChange={(e, s) => {
                      this.setState({
                        franchise_name: e,
                        loader: true
                      })
                      this.props.getSalesByItem({ field_office__uuid: s.key, created_at__month: filter.created_at__month, created_at__year: filter.created_at__year });

                    }}

                  >
                    <Option value="">All</Option>
                    {map(franchiseList, (item) => {
                      return (
                        <Option key={item.uuid} value={item.name}>{item.name}</Option>
                      )
                    })}
                  </Select>
                </div>
                <div className="fitem">
                  <DatePicker
                    format="MMM YYYY"
                    picker="month"
                    defaultValue={moment()}
                    allowClear={false}
                    onChange={(e) => {
                      this.setState({
                        selected_date: e,
                        loader: true
                      })
                      this.props.getSalesByItem({ field_office__uuid: filter.field_office__uuid, created_at__month: moment(e).format('MM'), created_at__year: moment(e).format('YYYY') });
                    }}
                    className="form-control" />
                </div>
              </div>
              <div className="forecast-block">
                <div className="mtable">

                </div>
              </div>
            </div>
          </div>
          <div className="frtable">
            {/* header */}
            <div className="frtop">
              <div className="frleft">
                <p>Franchise: {franchise_name} <br /> for period {moment(selected_date).format('MMM')} {moment(selected_date).format('YYYY')}</p>
              </div>

            </div>

            {/* Heading */}
            <div className="frhead">
              <div className="frleft">
                <h4>Product Sales</h4>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1"> <h4>Items</h4> </div>
                  <div className="flex-1"> <h4>{SalesByItem?.total_product_sales ? `$ ${formatToCurrency(SalesByItem?.total_product_sales)}` : '-'}</h4> </div>
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="frbody">
              <div className="frleft">
                {/* <p>Litter Bags</p>
                <ul>
                  {map(SalesByItem?.products?.litter_bags, (item, i) => {
                    return (<li key={i}>{item.name}</li>)
                  })}
                </ul>
                <p>Pet Waste Stations</p>
                <p>Shipping & Handling</p>
                <p>Products - Other</p> */}
                <ul>
                  {map(SalesByItem?.products?.products, (item, i) => {
                    return (
                      <li key={i}>{item.name}</li>
                    )
                  })}
                </ul>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1">
                    {/* <p>{SalesByItem?.products?.litter_bags_quantity}</p>
                    <ul>
                      {map(SalesByItem?.products?.litter_bags, (item, i) => {
                        return (<li key={i}>{item.quantity}</li>)
                      })}
                    </ul>
                    <p>{SalesByItem?.products?.pws_stations_quantity}</p>
                    <p>{SalesByItem?.products?.shipping_handling_quantity || '-'}</p>
                    <p>{SalesByItem?.products?.products_other_quantity || '-'}</p> */}
                    <ul>
                      {map(SalesByItem?.products?.products, (item, i) => {
                        return (<li key={i}>{item.quantity}</li>)
                      })}
                    </ul>
                  </div>
                  <div className="flex-1">
                    {/* <ul>
                      <li><b>{SalesByItem?.products?.litter_bags_price ? `$ ${SalesByItem?.products?.litter_bags_price}` : '-'}</b></li>
                      {map(SalesByItem?.products?.litter_bags, (item, i) => {
                        return (<li key={i}>${item.price}</li>)
                      })}
                    </ul>

                    <p>{SalesByItem?.products?.pws_stations_price ? `$ ${SalesByItem?.products?.pws_stations_price}` : '-'}</p>
                    <p>{SalesByItem?.products?.shipping_handling_price ? `$ ${SalesByItem?.products?.shipping_handling_price}` : '-'}</p>
                    <p>{SalesByItem?.products?.products_other_price ? `$ ${SalesByItem?.products?.products_other_price}` : '-'}</p> */}
                    <ul>
                      {map(SalesByItem?.products?.products, (item, i) => {
                        return (<li key={i}>${formatToCurrency(item.price)}</li>)
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Heading */}
            <div className="frhead">
              <div className="frleft">
                <h4>Services</h4>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1"> <h4>Items</h4> </div>
                  <div className="flex-1"> <h4>{SalesByItem?.total_services ? `$ ${formatToCurrency(SalesByItem?.total_services)}` : '-'}</h4> </div>
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="frbody">
              <div className="frleft">
                <p>Residential Services</p>
                <ul>
                  {map(SalesByItem?.services?.residential_services, (item, i) => {
                    return (
                      <li key={i}>{item.name}</li>
                    )
                  })}


                </ul>
                <p>Commercial Services</p>
                <ul className="pb-0">
                  {map(SalesByItem?.services?.commercial_services, (item, i) => {
                    return (
                      <li key={i}>{item.name}</li>
                    )
                  })}
                </ul>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1">
                    <p>&nbsp;</p>
                    <ul>
                      {map(SalesByItem?.services?.residential_services, (item, i) => {
                        return (
                          <li key={i}>{item.quantity}</li>
                        )
                      })}
                    </ul>
                    <p>&nbsp;</p>
                    <ul className="pb-0">
                      {map(SalesByItem?.services?.commercial_services, (item, i) => {
                        return (
                          <li key={i}>{item.quantity}</li>
                        )
                      })}
                    </ul>
                  </div>
                  <div className="flex-1">
                    {/* <p>-</p> */}
                    <p>{SalesByItem?.services?.total_residential ? `$ ${formatToCurrency(SalesByItem?.services?.total_residential)}` : '-'}</p>
                    <ul>
                      {map(SalesByItem?.services?.residential_services, (item, i) => {
                        return (
                          <li key={i}>${formatToCurrency(item.price)}</li>
                        )
                      })}
                    </ul>
                    {/* <p>-</p> */}
                    <p>{SalesByItem?.services?.total_commercial ? `$ ${formatToCurrency(SalesByItem?.services?.total_commercial)}` : '-'}</p>
                    <ul className="pb-0">
                      {map(SalesByItem?.services?.commercial_services, (item, i) => {
                        return (
                          <li key={i}>{formatToCurrency(item.price)}</li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Heading */}
            <div className="frhead">
              <div className="frleft">
                <h4>Discount</h4>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1"> <h4>Items</h4> </div>
                  <div className="flex-1"> <h4>- {SalesByItem?.total_discounts ? `$(${formatToCurrency(SalesByItem?.total_discounts)}) ` : '-'}</h4> </div>
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="frbody">
              <div className="frleft">
                <p>Coupons</p>
                <ul>
                  {map(SalesByItem?.discounts?.coupons, (item, i) => {
                    return (<li key={i}>{item.name}</li>)
                  })}
                </ul>
                <p>Call Center Reductions</p>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1">
                    <p>&nbsp;</p>
                    <ul>
                      {map(SalesByItem?.discounts?.coupons, (item, i) => {
                        return (<li key={i}>{item.quantity}</li>)
                      })}
                    </ul>
                    <p>{SalesByItem?.discounts?.total_call_center_qty ? SalesByItem?.discounts?.total_call_center_qty : '-'}</p>

                  </div>
                  <div className="flex-1">
                    <p>{SalesByItem?.discounts?.total_coupon_price ? formatToCurrency(SalesByItem?.discounts?.total_coupon_price) : '-'}</p>
                    <ul>
                      {map(SalesByItem?.discounts?.coupons, (item, i) => {
                        return (<li key={i}>${formatToCurrency(item.price)}</li>)
                      })}
                    </ul>
                    <p>{SalesByItem?.discounts?.total_call_center_qty ? `$ ${SalesByItem?.discounts?.total_call_center_qty}` : '-'}</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="frfoot">
              <div className="frleft">
                <h4>Sales total for franchise for period</h4>
              </div>
              <div className="frright">
                <div className="flex">
                  <div className="flex-1">
                    <h4>{SalesByItem?.total ? `$ ${formatToCurrency(SalesByItem?.total)}` : '-'}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default SalesByItem;